export default __webpack_public_path__ + "static/media/game_1_m.3d012adf.png";